import { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useTranslation } from 'react-i18next'
import { Form } from 'semantic-ui-react'
import { object, string } from 'yup'
import { useValidateForm } from '../../Common/Hooks/useValidateForm'
import { setCompanyData } from '../Slice/CompanySlice'
import SearchTag from '../../Tag/Views/SearchTag'

export default function CompanyForm () {
  const { t } = useTranslation()
  const { form: company, isLoading, isDirty } = useSelector((state) => state.company)
  const dispatch = useDispatch()

  const companySchema = object({
    name: string().required(t('generic.validation.name'))
  })
  const [errors, validate, handleChange] = useValidateForm(company, companySchema)

  const updateFormData = (data, isValid) => {
    dispatch(setCompanyData({ data, isValid }))
  }

  useEffect(() => {
    validate(company)
  }, [isDirty])

  return (
    <Form autoComplete='off' loading={isLoading}>
      <Form.Input
        label={ t('generic.name') }
        placeholder={ t('generic.name') }
        name='name'
        required
        value={company.name}
        error={isDirty && errors.name}
        onChange={ handleChange(updateFormData) } />
      <Form.Group>
        <SearchTag value={company.tag} onChange={ handleChange(updateFormData) } />
      </Form.Group>
      <Form.Input
        label={ t('generic.website') }
        placeholder={ t('generic.website') }
        name='url'
        value={company.url}
        onChange={ handleChange(updateFormData) } />
      <Form.Field
        label={ t('generic.description') }
        control='textarea'
        rows='5'
        className='no-resize'
        name='description'
        value={company.description}
        onChange={ handleChange(updateFormData) } />
    </Form>
  )
}
